var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecklist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    title: "Checklist",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 17.4874L12.7562 15.8687L11.875 16.7499L14.375 19.2499L18.75 14.8749L17.8688 13.9937L14.375 17.4874Z",
    fill: "#6E777F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 6.125C7.22018 6.125 7.5 5.84518 7.5 5.5C7.5 5.15482 7.22018 4.875 6.875 4.875C6.52982 4.875 6.25 5.15482 6.25 5.5C6.25 5.84518 6.52982 6.125 6.875 6.125Z",
    fill: "#6E777F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 11.125C7.22018 11.125 7.5 10.8452 7.5 10.5C7.5 10.1548 7.22018 9.875 6.875 9.875C6.52982 9.875 6.25 10.1548 6.25 10.5C6.25 10.8452 6.52982 11.125 6.875 11.125Z",
    fill: "#6E777F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 16.125C7.22018 16.125 7.5 15.8452 7.5 15.5C7.5 15.1548 7.22018 14.875 6.875 14.875C6.52982 14.875 6.25 15.1548 6.25 15.5C6.25 15.8452 6.52982 16.125 6.875 16.125Z",
    fill: "#6E777F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.375H5C4.66848 2.375 4.35054 2.5067 4.11612 2.74112C3.8817 2.97554 3.75 3.29348 3.75 3.625V17.375C3.75 17.7065 3.8817 18.0245 4.11612 18.2589C4.35054 18.4933 4.66848 18.625 5 18.625H10V17.375H5V13.625H16.25V3.625C16.25 3.29348 16.1183 2.97554 15.8839 2.74112C15.6495 2.5067 15.3315 2.375 15 2.375ZM15 12.375H5V8.625H15V12.375ZM15 7.375H5V3.625H15V7.375Z",
    fill: "#6E777F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.e6c20b77.svg";
export { ForwardRef as ReactComponent };